<template>
    <b-icon :icon="levelIcon(level)"
            :custom-class="iconClass"
            :size="size"
    />
</template>

<script>
    export default {
        data() {
            return {
                levelIcons: {
                    'rough-diamond': 'diamond-stone',
                    'rising-star': 'star-face',
                    mastermind: 'brain',
                },
            };
        },

        props: {
            level: {
                required: true,
                type: Object,
            },

            iconClass: {
                required: false,
                type: String,
            },

            size: {
                required: false,
                type: String,
            },
        },

        methods: {
            levelIcon(level) {
                const { name } = level;

                return this.levelIcons[name];
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/taskflex/levels/components/LevelIcon.vue